import { Td } from '@chakra-ui/react';

import { Deal } from '../../../gql/dealGql';

import { getDealAge, getDealAgeColor } from '../../../utils/deals';

type DealAgeProps = {
  deal: Deal;
};

const DealAge = ({ deal }: DealAgeProps) => {
  const dealAge = getDealAge(deal.completion_date_utc, deal.completion_date_tz ?? '').toString();

  return (
    <Td textAlign="center" color="white" bgColor={getDealAgeColor(parseInt(dealAge, 10))}>
      {dealAge}
    </Td>
  );
};

export default DealAge;
